<template>
  <div>
    <button class="btn btn-info m-2" @click="goBack">Back</button>
    <card class="card">
      <div>
        <div class="row px-4">
          <div class="col-12">
            <label>
              Enter Agent Wallet ID
              <span class="text-danger"
                >(Kindly Ensure Correct Wallet Id )</span
              >
            </label>
            <fg-input type="text" placeholder="walletId" v-model="walletId">
            </fg-input>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-info" round @click="getUser()">
            <div
              class="spinner-grow"
              role="status"
              v-if="loading.show === true"
            ></div>
            Search User Details
          </button>
        </div>

        <form @submit.prevent v-if="userConfirmed === true">
          <div class="row">
            <!-- <div class="col-12 mt-2">
                <label
                  >Select Institution to
                  {{
                    type === "debit" ? "Send Debited Funds" : " Debit from"
                  }}</label
                >
                <multiselect
                  v-model="selectedInstitution"
                  :custom-label="optionLabel"
                  track-by="_id"
                  :options="utils.institutions"
                  :allow-empty="false"
                  placeholder="Select an Institution"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    {{ option.institutionName }}
                  </template>
                </multiselect>
              </div> -->

            <div class="col-md-4">
              <h4>First Name | Last Name</h4>
              <p>
                {{ user.institutionName || user.merchantName }}
                {{ user.firstName }}
              </p>
            </div>

            <div class="col-md-4">
              <h4>Company Name</h4>
              <p>
                {{ user.companyName }}
              </p>
            </div>
            <div class="col-md-4">
              <h4>Email</h4>
              <p>
                {{ user.email }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <h4 for="inlineFormInput">Type</h4>
              <select class="form-control" v-model="type">
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </select>
            </div>
            <div class="col-md-4">
              <h4>Amount</h4>
              <fg-input type="number" placeholder="Amount" v-model="amount">
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <h4>Reference</h4>
              <fg-input type="text" placeholder="Reference" v-model="reference">
              </fg-input>
            </div>

            <div class="col-md-4">
              <h4>WalletID</h4>
              <p>
                {{ user.walletId }}
              </p>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Send
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      type: "debit",
      walletId: "",
      reference: "",
      amount: "",
      selectedInstitution: "",
      userConfirmed: false,
      user: {},
    };
  },
  computed: {
    ...mapState(["loading", "utils"]),
  },
  methods: {
    ...mapActions(["setNotification", "getInstitutions", "setLoading"]),
    goBack() {
      window.history.back();
    },
    submit() {
      this.$confirm(`${this.type.toUpperCase()} Wallet?`).then(async () => {
        try {
          const url = `${process.env.VUE_APP_API_URL}/initiate/request/load`;
          const res = await axios.post(url, {
            type: this.type,
            walletId: this.walletId,
            reference: this.reference,
            amount: this.amount,
          });

          const { message } = res.data;
          this.setNotification({
            type: "success",
            message: message || "Successful",
          });
          this.userConfirmed = false;
          this.user = {};
          return this.$router.push({ name: "Wallet Funding" });
        } catch (err) {
          const data = err.response
            ? err.response.data
            : { message: err.toString() };
          this.setNotification({
            type: "danger",
            message: data.message || "Failed",
          });
        }
      });
    },
    optionLabel({ institutionName, state, country }) {
      return `${institutionName}, ${state}, ${country}`;
    },
    async getUser() {
      try {
        this.userConfirmed = false;
        this.setLoading(true);
        const url = `${process.env.VUE_APP_API_URL}/user-details/admin/get-user-from-wallet`;
        const res = await axios.post(url, {
          walletId: this.walletId,
        });
        const { message, user } = res.data;
        this.setNotification({
          type: "success",
          message: message || "Successful",
        });
        this.user = user;
        this.userConfirmed = true;
      } catch (err) {
        if (err.response) {
          const { data } = err.response;
          if (data) {
            this.setNotification({
              type: "danger",
              message: data.message || "Failed",
            });
          }
        } else {
          this.setNotification({
            type: "danger",
            message: err.toString(),
          });
        }
      }
      this.setLoading(false);
    },
  },
  // mounted() {
  //   this.getInstitutions();
  // },
};
</script>
<style></style>
